import { createRouter, createWebHistory } from 'vue-router'
import ImovelDetailsPage from '@/pages/ImovelDetailsPage.vue'

const routes = [
  {
    path: '/',
    redirect: {
      name: 'imovel-sao-cleto',
      status: 302
    }
  },
  {
    path: '/imovel-sao-cleto',
    name: 'imovel-sao-cleto',
    component: ImovelDetailsPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
